import { AAQuestionnaireAnswer } from "./aa_questionnaire_answer";
import { Model } from "./model";

export class AAQuestionnaireQuestion extends Model {
	private question: string = "";
	private type: string = "";
	private answers: AAQuestionnaireAnswer[] = [];
	private input_placeholder: string = "";
	public inputValue: string = "";

	public getQuestion(): string {
		return this.question;
	}

	public setQuestion(q: string): void {
		this.question = q;
	}

	public getType(): string {
		return this.type;
	}

	public setType(t: string): void {
		this.type = t;
	}

	public getAnswers(): AAQuestionnaireAnswer[] {
		return this.answers;
	}

	public setAnswers(list: AAQuestionnaireAnswer[]): void {
		this.answers = list;
	}

	public getInputPlaceholder(): string {
		return this.input_placeholder;
	}

	public isInputField(): boolean {
		return this.type === "input_field";
	}

	public isSingleChoice(): boolean {
		return this.type === "single_choice";
	}
}
